import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  GetCityBrandsByCityId,
  EditCityBrands,
  GetAllCities,
  GetAllCityBrands,
  DeleteCityBrand,
  GetProvinces,
  GetCityByProvinceId,
} from "../../fetchs";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AlertDialog from "../Prompt/alert-dialog.component";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },

});

class CityBrand extends Component {
  constructor(props) {
    super(props);

    this.state = {
      provinceId: "",
      province: [],
      cityId: "",
      cityBrands: [],
      brands: [],
      cities: [],
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
      isAvailable: "",
      deleteId: null,
      alertDialog: false,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
  

    GetProvinces(0, 50)
      .then((response) => {
        this.setState({ loading: true });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error(error);
      });
    







    GetAllCityBrands()
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        this.setState({ brands: responseJson.data });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
    if (this.props.match.params.id) {
      let cityid = this.props.match.params.id;
      this.setState({ cityId: cityid }, () => {
        this.loadCityBrands();
      });
    }
  }

  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvince();
    });
  };











  getCitiesByProvince = () => {
    GetCityByProvinceId(this.state.provinceId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    // }
  };

  loadCityBrands = () => {
    this.setState({ loading: true });
    GetCityBrandsByCityId(this.state.cityId)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        this.setState({ cityBrands: responseJson }, () => {
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };


  handleSave = () => {
    var elements = document.getElementsByClassName("cityBrandCheck");
    var details = [];
    debugger;
    for (let i = 0; i < elements.length; i++) {
      details.push({
        brandId: this.state.brands[i].id,
        isAvailable: document.querySelector(
          `input[type='checkbox'][brandId='${this.state.brands[i].id}']`
        ).checked,
      });
    }
    this.setState({ cityBrands: details }, () => {
      if (this.state.cityId) this.saveCityBrands();
    });
  };

  saveCityBrands = () => {
    EditCityBrands(this.state.cityId, this.state.cityBrands)
      .then((response) => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          console.log("Done");
        }
        return response.json();
      })
      .then((responseJson) => {
        console.log(responseJson.message);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.loadCityBrands();
      // this.loadChecks();
    });
  };

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteCityBrand(this.state.deleteId)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status === 200)
          toast.success("برند در شهر با موفقیت حذف شد");
        else toast.error("خطای حذف برند در شهر");
       // this.loadCityBrands();

        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  };
  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <div className={classes.actions}>
              <Link to='/main/addcitybrand' className={classes.link}>
                <Button variant='contained' color='primary'>
                 مدیریت برندها در شهرها
                </Button>
              </Link>
            </div>
            <Typography component='h1' variant='h4' align='center'>
              برندها در شهرها
            </Typography>

            <React.Fragment>
              <form className={classes.container} noValidate autoComplete='off'>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id='standard-select-city'
                      select
                      label='استان'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId}
                      onChange={this.handleChangeProvince("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.province.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name} - {option.province}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id='standard-select-city'
                      select
                      fullWidth
                      label='شهر'
                      className={classes.textField}
                      value={this.state.cityId}
                      onChange={this.handleChange("cityId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.cities.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name} - {option.province}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <table style={{ width: "100%", textAlign: "center" }}>
                      <thead>
                        <tr>
                          <th>نام برند</th>
                          <th> نوع محصول</th>
                          <th>فعال/غیرفعال</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.cityBrands.map((cityBrand) => (
                          <tr>
                            <td>{cityBrand.brandName}</td>
                            <td>{cityBrand.goodTypeName}</td>

                            {cityBrand.isAvailable ? (
                              <td align='center'>
                                <CheckCircleIcon color='primary' />
                              </td>
                            ) : (
                              <td align='center'>
                                <HighlightOffIcon />
                              </td>
                            )}

                            <td>
                              <Link to={`/main/addcitybrand/${cityBrand.id}`}>
                                <EditIcon color='primary' />
                              </Link>
                              <DeleteIcon
                                className='deleteIcon'
                                onClick={() =>
                                  this.handlePrepareDelete(cityBrand.id)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
        </main>
        <AlertDialog
          open={this.state.alertDialog}
          title={`هشدار`}
          body={`آیا از حذف  برند  در این شهر اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={3000}
          open={this.state.openSnackbar}
          ContentProps={{
            "aria-describedby": "message-id",
            class:
              "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
          }}
          message={<span id='message-id'> {this.state.errorMessage} </span>}
          onClose={() => this.handleCloseSnackbar(false)}
        />
      </React.Fragment>
    );
  }
}

CityBrand.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(CityBrand));
